import Vue from "vue";
import VueRouter from "vue-router";
import {
  routerBeforeEachFunc,
  routerAfterEachFunc
} from "@/config/interceptors/router";
import Layout from "@/layouts/layout";
Vue.use(VueRouter);

// const sem = [
//   {
//     path: "/sem/:public/m/:id",
//     name: "mArticle",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/mArticle.vue")
//   },
//   {
//     path: "/sem/:public/m/:id/redirect",
//     name: "mArticleRe",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/mArticleRe.vue")
//   },
//   {
//     path: "/sem/:public/p/:id",
//     name: "pArticle",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/pArticle.vue")
//   },
//   {
//     path: "/sem/:public/p/:id/redirect",
//     name: "pArticleRe",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/pArticleRe.vue")
//   },
//   {
//     path: "/sem/fd",
//     name: "fans",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/fans.vue")
//   },
//   {
//     path: "/sem/landing/:mp",
//     name: "landingMp",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/landingV2.vue")
//   },
//   {
//     path: "/sem/ab/:id",
//     name: "ab",
//     component: () => import(/* webpackChunkName: "sem" */ "../views/sem/ab.vue")
//   },
//   {
//     path: "/sem/plan",
//     name: "plan",
//     component: () =>
//       import(/* webpackChunkName: "sem" */ "../views/sem/bxPlan.vue")
//   }
// ];

const routes = [
  // ...sem,
  {
    path: "/",
    name: "Home",
    component: Layout,
    children: [
      {
        path: "/tracker",
        name: "Tracker",
        component: () =>
          import(/* webpackChunkName: "tracker" */ "../views/tracker.vue")
      },
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "offical" */ "../views/home.vue")
      },
      {
        path: "/consult",
        name: "Consult",
        component: () =>
          import(/* webpackChunkName: "offical" */ "../views/consult.vue")
      },
      {
        path: "/about/:id",
        name: "About",
        component: () =>
          import(/* webpackChunkName: "offical" */ "../views/about.vue")
      },
      {
        path: "/information/:id",
        name: "Information",
        component: () =>
          import(/* webpackChunkName: "offical" */ "../views/information.vue")
      },
      {
        path: "/directAdd",
        name: "DirectAdd",
        component: () =>
          import(/* webpackChunkName: "directAdd" */ "../views/sem/directAdd")
      },
      {
        path: "/directAdd/daRes",
        name: "DaRes",
        component: () =>
          import(/* webpackChunkName: "directAdd" */ "../views/sem/daRes")
      }
    ]
  },
  {
    path: "*",
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    if (to.path.indexOf("/information") !== -1) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach(routerBeforeEachFunc);
router.afterEach(routerAfterEachFunc);

export default router;
